import { Arc as ArcLayout } from '../data/utils/arc';
/**
 * For arc diagram(edge with weight) or chord diagram(with weight)
 */
export const Arc = (options) => {
    return (data) => {
        return ArcLayout(options)(data);
    };
};
Arc.props = {};
//# sourceMappingURL=arc.js.map